import {
  Mail,
  MapPin,
  MessageCircleMore,
  PencilLine,
  Phone,
} from "lucide-react";
import { Customer } from "src/redux/types/_customer.type";
import { formatDate, fullName, initials } from "src/utils";
import EditCustomerDialog from "./edit-customer-dialog";
import { useState } from "react";

const CustomerHeader = ({
  customer,
}: {
  customer: Customer;
}) => {
  const name = fullName(customer);

  const [isOpen, setIsOpen] = useState(false);
  const dialogClose = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="overflow-hidden rounded-3xl py-8 px-8 border mb-4 bg-gray-100/40 backdrop-blur-sm relative">
      <div className="absolute top-3 right-3">
        <button className="rounded-full p-2 border backdrop-blur-md hover:bg-gray-200 shadow-md hover:shadow-lg duration-300 ease-in-out transition-all" onClick={() => setIsOpen(!isOpen)}>
          <PencilLine className="size-5" />
        </button>
      </div>

      <div className="flex gap-6 items-center">
        <div className="flex size-20 shrink-0 items-center justify-center rounded-full bg-blue-50 text-2xl font-semibold text-blue-500 ring-1 ring-blue-500/20">
          {initials(name)}
        </div>
        <div className="min-w-0 flex-1">
          <h1 className="mt-1 truncate lg:text-2xl font-semibold text-primary-foreground capitalize">
            {name}
          </h1>
          <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-primary-foreground/85">
            <span className="inline-flex items-center gap-2">
              <Mail className="size-4" /> {customer.email}
            </span>
            <span className="inline-flex items-center gap-2">
              <Phone className="size-4" /> {customer.phone_no}
            </span>
            <span className="inline-flex items-center gap-2 text-green-500">
              <MessageCircleMore className="size-4" />{" "}
              {customer.whatsapp_number
                ? customer.whatsapp_number
                : customer.phone_no}
            </span>
          </div>
          <div>
            <span className="inline-flex items-center gap-2 text-sm text-muted">
              <MapPin className="size-4" /> {customer.city}, {customer.district}
              , {customer.state}, {customer.pin}
            </span>
          </div>
        </div>

        <div className="self-end">
          <p className="text-sm text-muted">
            Registered on:{" "}
            {customer.created_at && formatDate(customer.created_at)}
          </p>
        </div>
      </div>

      <EditCustomerDialog
        customer={customer}
        open={isOpen}
        close={dialogClose}
      />
    </header>
  );
};

export default CustomerHeader;
